export default __webpack_public_path__ + "static/media/heart.72ce2e4f.svg";